import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

const HeroSliderOneSingle = ({ data, sliderClassName, forTestOnly }) => {
  //console.log("one single: " + data.id)
  return (
    <div
      className={`${forTestOnly ? "" : 'single-slider slider-height-1'}  bg-white ${sliderClassName ? sliderClassName : ""
        }`}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-6 col-12 col-sm-6">
            <div className="slider-content slider-animated-1">
              <h3 className="animated">{data.title}</h3>
              <h1 className="animated">{data.subtitle}
                <img className="animated" src={data.headImage} style={{ width: "20%" }} /></h1>

              <div className="slider-btn btn-hover">
                {forTestOnly ?
                  <a target={'_blank'} href = {data?.url?.substring(0, 4) === 'http' ? data.url : process.env.PUBLIC_URL + data.url} > {data.buttonCaption || 'Acquista Ora'} </a>
                  :
                  <Link
                    className="animated"
                    to={data?.url?.substring(0, 4) === 'http' ? data.url : process.env.PUBLIC_URL + data.url}
                  >
                    {data.buttonCaption || 'Acquista Ora'}
                  </Link>
                }
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-12 col-sm-6">
            <div className="slider-single-img slider-animated-1">
              <img
                className="animated img-fluid"
                src={data?.image?.substring(0, 4) === 'http' ? data.image : process.env.PUBLIC_URL + data.image}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

HeroSliderOneSingle.propTypes = {
  data: PropTypes.object,
  sliderClassName: PropTypes.string
};

export default HeroSliderOneSingle;
